import styled, { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
`;

export const MainSection = styled.section<{
  $bgImage?: string;
  $bgColor?: string;
}>`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  background: ${({ $bgImage, $bgColor }) =>
    $bgImage ? `url(${$bgImage})` : `${$bgColor}`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export const MainInner = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 40px 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 48px 42px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xxl}) {
    padding: 80px 116px;
  }
`;

export default GlobalStyle;
